module.exports = __webpack_public_path__ + "img/settings.1eee6b9f.svg";